import { render } from "./CategoriesPopUpFilter.vue?vue&type=template&id=4c071ba8&scoped=true"
import script from "./CategoriesPopUpFilter.vue?vue&type=script&lang=js"
export * from "./CategoriesPopUpFilter.vue?vue&type=script&lang=js"

import "./CategoriesPopUpFilter.vue?vue&type=style&index=0&id=4c071ba8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c071ba8"],['__file',"src/components/CategoriesPopUpFilter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4c071ba8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4c071ba8', __exports__)) {
    api.reload('4c071ba8', __exports__)
  }
  
  module.hot.accept("./CategoriesPopUpFilter.vue?vue&type=template&id=4c071ba8&scoped=true", () => {
    api.rerender('4c071ba8', render)
  })

}


export default __exports__